// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/bulkaction/v1/bulkaction.proto" (package "c1.api.bulkaction.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { Empty } from "../../../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { AppManagedStateBindingRef } from "../../app/v1/app_managed";
import { AppResourceRef } from "../../app/v1/app_resource";
import { AppUserRef } from "../../app/v1/app_user";
import { AppEntitlementUserBindingRef } from "../../app/v1/app_refs";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { AppRef } from "../../app/v1/app";
import { AppUserType } from "../../app/v1/app_user";
import { AppUserSearchFilter } from "../../app/v1/app_user";
import { AppResourceSearchFilter } from "../../app/v1/app_resource";
import { AppManagedStateBindingSearchFilter } from "../../app/v1/app_managed";
import { AppEntitlementUserBindingSearchFilter } from "../../app/v1/app_entitlement";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { AppEntitlement } from "../../app/v1/app_entitlement";
import { AppEntitlementSearchFilter } from "../../app/v1/app_entitlement";
import { AppSearchFilter } from "../../app/v1/app";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionGetRequest
 */
export interface BulkActionGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionDeleteRequest
 */
export interface BulkActionDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionListRequest
 */
export interface BulkActionListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionListResponse
 */
export interface BulkActionListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.bulkaction.v1.BulkAction list = 1
     */
    list: BulkAction[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionArgs
 */
export interface BulkActionArgs {
    /**
     * @generated from protobuf oneof: typ
     */
    typ: {
        oneofKind: "assignAppOwnersAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.AssignAppOwnersAction assign_app_owners_action = 1
         */
        assignAppOwnersAction: AssignAppOwnersAction;
    } | {
        oneofKind: "setAppEntitlementAccessRequestsAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.SetAppEntitlementAccessRequestsAction set_app_entitlement_access_requests_action = 2
         */
        setAppEntitlementAccessRequestsAction: SetAppEntitlementAccessRequestsAction;
    } | {
        oneofKind: "createRevokeTicketsAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.CreateRevokeTicketsAction create_revoke_tickets_action = 3
         */
        createRevokeTicketsAction: CreateRevokeTicketsAction;
    } | {
        oneofKind: "setAppEntitlementProvisionPolicyAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.SetAppEntitlementProvisionPolicyAction set_app_entitlement_provision_policy_action = 4
         */
        setAppEntitlementProvisionPolicyAction: SetAppEntitlementProvisionPolicyAction;
    } | {
        oneofKind: "assignAppEntitlementOwnersAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.AssignAppEntitlementOwnersAction assign_app_entitlement_owners_action = 5
         */
        assignAppEntitlementOwnersAction: AssignAppEntitlementOwnersAction;
    } | {
        oneofKind: "setAppUserAccountTypeAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.SetAppUserAccountTypeAction set_app_user_account_type_action = 6
         */
        setAppUserAccountTypeAction: SetAppUserAccountTypeAction;
    } | {
        oneofKind: "assignAppResourceOwnersAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.AssignAppResourceOwnersAction assign_app_resource_owners_action = 7
         */
        assignAppResourceOwnersAction: AssignAppResourceOwnersAction;
    } | {
        oneofKind: "setGrantExpirationAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.SetGrantExpirationAction set_grant_expiration_action = 8
         */
        setGrantExpirationAction: SetGrantExpirationAction;
    } | {
        oneofKind: "removeGrantExpirationAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.RemoveGrantExpirationAction remove_grant_expiration_action = 9
         */
        removeGrantExpirationAction: RemoveGrantExpirationAction;
    } | {
        oneofKind: "promoteAppManagedStateBindingAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.PromoteAppManagedStateBindingAction promote_app_managed_state_binding_action = 10
         */
        promoteAppManagedStateBindingAction: PromoteAppManagedStateBindingAction;
    } | {
        oneofKind: "setAppUserOwnerAction";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.SetAppUserOwnerAction set_app_user_owner_action = 11
         */
        setAppUserOwnerAction: SetAppUserOwnerAction;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionCreateRequest
 */
export interface BulkActionCreateRequest {
    /**
     * @generated from protobuf field: c1.api.bulkaction.v1.BulkActionArgs args = 1
     */
    args?: BulkActionArgs;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkAction
 */
export interface BulkAction {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.bulkaction.v1.BulkActionArgs args = 2
     */
    args?: BulkActionArgs;
    /**
     * @generated from protobuf field: c1.api.bulkaction.v1.BulkActionState state = 3
     */
    state: BulkActionState;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string created_by_id = 7
     */
    createdById: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.AssignAppOwnersAction
 */
export interface AssignAppOwnersAction {
    /**
     * A filter to search for apps to assign owners to
     *
     * @generated from protobuf field: c1.api.app.v1.AppSearchFilter filter = 1
     */
    filter?: AppSearchFilter;
    /**
     * A list of user ids to assign as owners
     *
     * @generated from protobuf field: repeated string user_ids = 2
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.CatalogIds
 */
export interface CatalogIds {
    /**
     * @generated from protobuf field: repeated string ids = 1
     */
    ids: string[];
    /**
     * @generated from protobuf field: repeated string preserve_ids = 2
     */
    preserveIds: string[];
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.SetAppEntitlementAccessRequestsAction
 */
export interface SetAppEntitlementAccessRequestsAction {
    /**
     * A filter to search for app entitlements to update
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementSearchFilter filter = 1
     */
    filter?: AppEntitlementSearchFilter;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement update_app_entitlement = 2
     */
    updateAppEntitlement?: AppEntitlement;
    /**
     * A comma sepparated list of fields to update from the entitlement. For example: "certify_policy_id,slug"
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 3
     */
    updateMask?: FieldMask;
    /**
     * A list of catalog ids that should contain the app entitlement
     *
     * @generated from protobuf oneof: catalogs
     */
    catalogs: {
        oneofKind: "setCatalogIds";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.CatalogIds set_catalog_ids = 5
         */
        setCatalogIds: CatalogIds;
    } | {
        oneofKind: "ignoreCatalogIds";
        /**
         * @generated from protobuf field: bool ignore_catalog_ids = 8
         */
        ignoreCatalogIds: boolean;
    } | {
        oneofKind: "addCatalogIds";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.CatalogIds add_catalog_ids = 9
         */
        addCatalogIds: CatalogIds;
    } | {
        oneofKind: "removeCatalogIds";
        /**
         * @generated from protobuf field: c1.api.bulkaction.v1.CatalogIds remove_catalog_ids = 10
         */
        removeCatalogIds: CatalogIds;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.CreateRevokeTicketsAction
 */
export interface CreateRevokeTicketsAction {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingSearchFilter filter = 1
     */
    filter?: AppEntitlementUserBindingSearchFilter;
    /**
     * @generated from protobuf field: string reason = 2
     */
    reason: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.SetAppEntitlementProvisionPolicyAction
 */
export interface SetAppEntitlementProvisionPolicyAction {
    /**
     * A filter to search for app entitlements to update
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementSearchFilter filter = 1
     */
    filter?: AppEntitlementSearchFilter;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement update_app_entitlement = 2
     */
    updateAppEntitlement?: AppEntitlement;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.SetGrantExpirationAction
 */
export interface SetGrantExpirationAction {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingSearchFilter filter = 1
     */
    filter?: AppEntitlementUserBindingSearchFilter;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deprovision_at = 2
     */
    deprovisionAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.RemoveGrantExpirationAction
 */
export interface RemoveGrantExpirationAction {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingSearchFilter filter = 1
     */
    filter?: AppEntitlementUserBindingSearchFilter;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.PromoteAppManagedStateBindingAction
 */
export interface PromoteAppManagedStateBindingAction {
    /**
     * A filter to search for app managed state bindings to promote
     *
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingSearchFilter filter = 1
     */
    filter?: AppManagedStateBindingSearchFilter;
    /**
     * A list of user ids to assign as owners
     *
     * @generated from protobuf field: repeated string user_ids = 2
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.AssignAppEntitlementOwnersAction
 */
export interface AssignAppEntitlementOwnersAction {
    /**
     * A filter to search for app entitlements to update
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementSearchFilter filter = 1
     */
    filter?: AppEntitlementSearchFilter;
    /**
     * A list of user ids to assign as owners
     *
     * @generated from protobuf field: repeated string user_ids = 2
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.AssignAppResourceOwnersAction
 */
export interface AssignAppResourceOwnersAction {
    /**
     * A filter to search for resources to assign owners to
     *
     * @generated from protobuf field: c1.api.app.v1.AppResourceSearchFilter filter = 1
     */
    filter?: AppResourceSearchFilter;
    /**
     * A list of user ids to assign as owners
     *
     * @generated from protobuf field: repeated string user_ids = 2
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.SetAppUserAccountTypeAction
 */
export interface SetAppUserAccountTypeAction {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserSearchFilter filter = 1
     */
    filter?: AppUserSearchFilter;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserType update_app_user_type = 2
     */
    updateAppUserType: AppUserType;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.SetAppUserOwnerAction
 */
export interface SetAppUserOwnerAction {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserSearchFilter filter = 1
     */
    filter?: AppUserSearchFilter;
    /**
     * @generated from protobuf field: string user_id = 2
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionRef
 */
export interface BulkActionRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionListItemsRequest
 */
export interface BulkActionListItemsRequest {
    /**
     * @generated from protobuf field: string bulk_action_id = 1
     */
    bulkActionId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionListItemsResponse
 */
export interface BulkActionListItemsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.bulkaction.v1.BulkActionItem list = 1
     */
    list: BulkActionItem[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionListCompletedItemsRequest
 */
export interface BulkActionListCompletedItemsRequest {
    /**
     * @generated from protobuf field: string bulk_action_id = 1
     */
    bulkActionId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionListCompletedItemsResponse
 */
export interface BulkActionListCompletedItemsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.bulkaction.v1.CompletedBulkActionItem list = 1
     */
    list: CompletedBulkActionItem[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.BulkActionItem
 */
export interface BulkActionItem {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string bulk_action_id = 2
     */
    bulkActionId: string;
    /**
     * @generated from protobuf field: string id = 3
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.bulkaction.v1.BulkActionItemState state = 4
     */
    state: BulkActionItemState;
    /**
     * @generated from protobuf field: string error_message = 5
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 8
     */
    deletedAt?: Timestamp;
    /**
     * Ref to the object this BulkActionItem is acting on
     *
     * @generated from protobuf oneof: ref
     */
    ref: {
        oneofKind: "appRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppRef app_ref = 9
         */
        appRef: AppRef;
    } | {
        oneofKind: "appEntitlementRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef app_entitlement_ref = 10
         */
        appEntitlementRef: AppEntitlementRef;
    } | {
        oneofKind: "appEntitlementUserBindingRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingRef app_entitlement_user_binding_ref = 11
         */
        appEntitlementUserBindingRef: AppEntitlementUserBindingRef;
    } | {
        oneofKind: "appUserRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppUserRef app_user_ref = 12
         */
        appUserRef: AppUserRef;
    } | {
        oneofKind: "appResourceRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppResourceRef app_resource_ref = 13
         */
        appResourceRef: AppResourceRef;
    } | {
        oneofKind: "appManagedStateBindingRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingRef app_managed_state_binding_ref = 14
         */
        appManagedStateBindingRef: AppManagedStateBindingRef;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.bulkaction.v1.CompletedBulkActionItem
 */
export interface CompletedBulkActionItem {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string bulk_action_id = 2
     */
    bulkActionId: string;
    /**
     * @generated from protobuf field: string id = 3
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.bulkaction.v1.BulkActionItemState state = 4
     */
    state: BulkActionItemState;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 8
     */
    expiresAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.bulkaction.v1.BulkActionItem bulk_action_item = 9
     */
    bulkActionItem?: BulkActionItem;
}
/**
 * @generated from protobuf enum c1.api.bulkaction.v1.BulkActionState
 */
export enum BulkActionState {
    /**
     * @generated from protobuf enum value: BULK_ACTION_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * initial state
     *
     * @generated from protobuf enum value: BULK_ACTION_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * creating bulk action items
     *
     * @generated from protobuf enum value: BULK_ACTION_STATE_CREATING = 2;
     */
    CREATING = 2,
    /**
     * processing each bulk action item
     *
     * @generated from protobuf enum value: BULK_ACTION_STATE_PROCESSING = 3;
     */
    PROCESSING = 3,
    /**
     * successfully done
     *
     * @generated from protobuf enum value: BULK_ACTION_STATE_DONE = 4;
     */
    DONE = 4,
    /**
     * cancelled
     *
     * @generated from protobuf enum value: BULK_ACTION_STATE_CANCELED = 5;
     */
    CANCELED = 5,
    /**
     * the entire bulk action errored (usually on creating items) terminal error.
     *
     * @generated from protobuf enum value: BULK_ACTION_STATE_ERRORED = 6;
     */
    ERRORED = 6
}
/**
 * @generated from protobuf enum c1.api.bulkaction.v1.BulkActionItemState
 */
export enum BulkActionItemState {
    /**
     * @generated from protobuf enum value: BULK_ACTION_ITEM_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * processing
     *
     * @generated from protobuf enum value: BULK_ACTION_ITEM_STATE_IN_PROGRESS = 1;
     */
    IN_PROGRESS = 1,
    /**
     * successfully done
     *
     * @generated from protobuf enum value: BULK_ACTION_ITEM_STATE_DONE = 2;
     */
    DONE = 2,
    /**
     * cancelled
     *
     * @generated from protobuf enum value: BULK_ACTION_ITEM_STATE_CANCELED = 3;
     */
    CANCELED = 3,
    /**
     * terminal error
     *
     * @generated from protobuf enum value: BULK_ACTION_ITEM_STATE_ERRORED = 4;
     */
    ERRORED = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionGetRequest$Type extends MessageType<BulkActionGetRequest> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<BulkActionGetRequest>): BulkActionGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<BulkActionGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkActionGetRequest): BulkActionGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkActionGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionGetRequest
 */
export const BulkActionGetRequest = new BulkActionGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionDeleteRequest$Type extends MessageType<BulkActionDeleteRequest> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<BulkActionDeleteRequest>): BulkActionDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<BulkActionDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkActionDeleteRequest): BulkActionDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkActionDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionDeleteRequest
 */
export const BulkActionDeleteRequest = new BulkActionDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionListRequest$Type extends MessageType<BulkActionListRequest> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<BulkActionListRequest>): BulkActionListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<BulkActionListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkActionListRequest): BulkActionListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkActionListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionListRequest
 */
export const BulkActionListRequest = new BulkActionListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionListResponse$Type extends MessageType<BulkActionListResponse> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BulkAction },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<BulkActionListResponse>): BulkActionListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<BulkActionListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkActionListResponse): BulkActionListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.bulkaction.v1.BulkAction list */ 1:
                    message.list.push(BulkAction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkActionListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.bulkaction.v1.BulkAction list = 1; */
        for (let i = 0; i < message.list.length; i++)
            BulkAction.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionListResponse
 */
export const BulkActionListResponse = new BulkActionListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionArgs$Type extends MessageType<BulkActionArgs> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionArgs", [
            { no: 1, name: "assign_app_owners_action", kind: "message", oneof: "typ", T: () => AssignAppOwnersAction },
            { no: 2, name: "set_app_entitlement_access_requests_action", kind: "message", oneof: "typ", T: () => SetAppEntitlementAccessRequestsAction },
            { no: 3, name: "create_revoke_tickets_action", kind: "message", oneof: "typ", T: () => CreateRevokeTicketsAction },
            { no: 4, name: "set_app_entitlement_provision_policy_action", kind: "message", oneof: "typ", T: () => SetAppEntitlementProvisionPolicyAction },
            { no: 5, name: "assign_app_entitlement_owners_action", kind: "message", oneof: "typ", T: () => AssignAppEntitlementOwnersAction },
            { no: 6, name: "set_app_user_account_type_action", kind: "message", oneof: "typ", T: () => SetAppUserAccountTypeAction },
            { no: 7, name: "assign_app_resource_owners_action", kind: "message", oneof: "typ", T: () => AssignAppResourceOwnersAction },
            { no: 8, name: "set_grant_expiration_action", kind: "message", oneof: "typ", T: () => SetGrantExpirationAction },
            { no: 9, name: "remove_grant_expiration_action", kind: "message", oneof: "typ", T: () => RemoveGrantExpirationAction },
            { no: 10, name: "promote_app_managed_state_binding_action", kind: "message", oneof: "typ", T: () => PromoteAppManagedStateBindingAction },
            { no: 11, name: "set_app_user_owner_action", kind: "message", oneof: "typ", T: () => SetAppUserOwnerAction }
        ]);
    }
    create(value?: PartialMessage<BulkActionArgs>): BulkActionArgs {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.typ = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<BulkActionArgs>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkActionArgs): BulkActionArgs {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.bulkaction.v1.AssignAppOwnersAction assign_app_owners_action */ 1:
                    message.typ = {
                        oneofKind: "assignAppOwnersAction",
                        assignAppOwnersAction: AssignAppOwnersAction.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).assignAppOwnersAction)
                    };
                    break;
                case /* c1.api.bulkaction.v1.SetAppEntitlementAccessRequestsAction set_app_entitlement_access_requests_action */ 2:
                    message.typ = {
                        oneofKind: "setAppEntitlementAccessRequestsAction",
                        setAppEntitlementAccessRequestsAction: SetAppEntitlementAccessRequestsAction.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).setAppEntitlementAccessRequestsAction)
                    };
                    break;
                case /* c1.api.bulkaction.v1.CreateRevokeTicketsAction create_revoke_tickets_action */ 3:
                    message.typ = {
                        oneofKind: "createRevokeTicketsAction",
                        createRevokeTicketsAction: CreateRevokeTicketsAction.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).createRevokeTicketsAction)
                    };
                    break;
                case /* c1.api.bulkaction.v1.SetAppEntitlementProvisionPolicyAction set_app_entitlement_provision_policy_action */ 4:
                    message.typ = {
                        oneofKind: "setAppEntitlementProvisionPolicyAction",
                        setAppEntitlementProvisionPolicyAction: SetAppEntitlementProvisionPolicyAction.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).setAppEntitlementProvisionPolicyAction)
                    };
                    break;
                case /* c1.api.bulkaction.v1.AssignAppEntitlementOwnersAction assign_app_entitlement_owners_action */ 5:
                    message.typ = {
                        oneofKind: "assignAppEntitlementOwnersAction",
                        assignAppEntitlementOwnersAction: AssignAppEntitlementOwnersAction.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).assignAppEntitlementOwnersAction)
                    };
                    break;
                case /* c1.api.bulkaction.v1.SetAppUserAccountTypeAction set_app_user_account_type_action */ 6:
                    message.typ = {
                        oneofKind: "setAppUserAccountTypeAction",
                        setAppUserAccountTypeAction: SetAppUserAccountTypeAction.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).setAppUserAccountTypeAction)
                    };
                    break;
                case /* c1.api.bulkaction.v1.AssignAppResourceOwnersAction assign_app_resource_owners_action */ 7:
                    message.typ = {
                        oneofKind: "assignAppResourceOwnersAction",
                        assignAppResourceOwnersAction: AssignAppResourceOwnersAction.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).assignAppResourceOwnersAction)
                    };
                    break;
                case /* c1.api.bulkaction.v1.SetGrantExpirationAction set_grant_expiration_action */ 8:
                    message.typ = {
                        oneofKind: "setGrantExpirationAction",
                        setGrantExpirationAction: SetGrantExpirationAction.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).setGrantExpirationAction)
                    };
                    break;
                case /* c1.api.bulkaction.v1.RemoveGrantExpirationAction remove_grant_expiration_action */ 9:
                    message.typ = {
                        oneofKind: "removeGrantExpirationAction",
                        removeGrantExpirationAction: RemoveGrantExpirationAction.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).removeGrantExpirationAction)
                    };
                    break;
                case /* c1.api.bulkaction.v1.PromoteAppManagedStateBindingAction promote_app_managed_state_binding_action */ 10:
                    message.typ = {
                        oneofKind: "promoteAppManagedStateBindingAction",
                        promoteAppManagedStateBindingAction: PromoteAppManagedStateBindingAction.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).promoteAppManagedStateBindingAction)
                    };
                    break;
                case /* c1.api.bulkaction.v1.SetAppUserOwnerAction set_app_user_owner_action */ 11:
                    message.typ = {
                        oneofKind: "setAppUserOwnerAction",
                        setAppUserOwnerAction: SetAppUserOwnerAction.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).setAppUserOwnerAction)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkActionArgs, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.bulkaction.v1.AssignAppOwnersAction assign_app_owners_action = 1; */
        if (message.typ.oneofKind === "assignAppOwnersAction")
            AssignAppOwnersAction.internalBinaryWrite(message.typ.assignAppOwnersAction, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.bulkaction.v1.SetAppEntitlementAccessRequestsAction set_app_entitlement_access_requests_action = 2; */
        if (message.typ.oneofKind === "setAppEntitlementAccessRequestsAction")
            SetAppEntitlementAccessRequestsAction.internalBinaryWrite(message.typ.setAppEntitlementAccessRequestsAction, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.bulkaction.v1.CreateRevokeTicketsAction create_revoke_tickets_action = 3; */
        if (message.typ.oneofKind === "createRevokeTicketsAction")
            CreateRevokeTicketsAction.internalBinaryWrite(message.typ.createRevokeTicketsAction, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.bulkaction.v1.SetAppEntitlementProvisionPolicyAction set_app_entitlement_provision_policy_action = 4; */
        if (message.typ.oneofKind === "setAppEntitlementProvisionPolicyAction")
            SetAppEntitlementProvisionPolicyAction.internalBinaryWrite(message.typ.setAppEntitlementProvisionPolicyAction, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.bulkaction.v1.AssignAppEntitlementOwnersAction assign_app_entitlement_owners_action = 5; */
        if (message.typ.oneofKind === "assignAppEntitlementOwnersAction")
            AssignAppEntitlementOwnersAction.internalBinaryWrite(message.typ.assignAppEntitlementOwnersAction, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.bulkaction.v1.SetAppUserAccountTypeAction set_app_user_account_type_action = 6; */
        if (message.typ.oneofKind === "setAppUserAccountTypeAction")
            SetAppUserAccountTypeAction.internalBinaryWrite(message.typ.setAppUserAccountTypeAction, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.bulkaction.v1.AssignAppResourceOwnersAction assign_app_resource_owners_action = 7; */
        if (message.typ.oneofKind === "assignAppResourceOwnersAction")
            AssignAppResourceOwnersAction.internalBinaryWrite(message.typ.assignAppResourceOwnersAction, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.bulkaction.v1.SetGrantExpirationAction set_grant_expiration_action = 8; */
        if (message.typ.oneofKind === "setGrantExpirationAction")
            SetGrantExpirationAction.internalBinaryWrite(message.typ.setGrantExpirationAction, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.bulkaction.v1.RemoveGrantExpirationAction remove_grant_expiration_action = 9; */
        if (message.typ.oneofKind === "removeGrantExpirationAction")
            RemoveGrantExpirationAction.internalBinaryWrite(message.typ.removeGrantExpirationAction, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.bulkaction.v1.PromoteAppManagedStateBindingAction promote_app_managed_state_binding_action = 10; */
        if (message.typ.oneofKind === "promoteAppManagedStateBindingAction")
            PromoteAppManagedStateBindingAction.internalBinaryWrite(message.typ.promoteAppManagedStateBindingAction, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.bulkaction.v1.SetAppUserOwnerAction set_app_user_owner_action = 11; */
        if (message.typ.oneofKind === "setAppUserOwnerAction")
            SetAppUserOwnerAction.internalBinaryWrite(message.typ.setAppUserOwnerAction, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionArgs
 */
export const BulkActionArgs = new BulkActionArgs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionCreateRequest$Type extends MessageType<BulkActionCreateRequest> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionCreateRequest", [
            { no: 1, name: "args", kind: "message", T: () => BulkActionArgs }
        ]);
    }
    create(value?: PartialMessage<BulkActionCreateRequest>): BulkActionCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BulkActionCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkActionCreateRequest): BulkActionCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.bulkaction.v1.BulkActionArgs args */ 1:
                    message.args = BulkActionArgs.internalBinaryRead(reader, reader.uint32(), options, message.args);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkActionCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.bulkaction.v1.BulkActionArgs args = 1; */
        if (message.args)
            BulkActionArgs.internalBinaryWrite(message.args, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionCreateRequest
 */
export const BulkActionCreateRequest = new BulkActionCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkAction$Type extends MessageType<BulkAction> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkAction", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "args", kind: "message", T: () => BulkActionArgs },
            { no: 3, name: "state", kind: "enum", T: () => ["c1.api.bulkaction.v1.BulkActionState", BulkActionState, "BULK_ACTION_STATE_"] },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "created_by_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<BulkAction>): BulkAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.state = 0;
        message.createdById = "";
        if (value !== undefined)
            reflectionMergePartial<BulkAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkAction): BulkAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.bulkaction.v1.BulkActionArgs args */ 2:
                    message.args = BulkActionArgs.internalBinaryRead(reader, reader.uint32(), options, message.args);
                    break;
                case /* c1.api.bulkaction.v1.BulkActionState state */ 3:
                    message.state = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 6:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string created_by_id */ 7:
                    message.createdById = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* c1.api.bulkaction.v1.BulkActionArgs args = 2; */
        if (message.args)
            BulkActionArgs.internalBinaryWrite(message.args, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.bulkaction.v1.BulkActionState state = 3; */
        if (message.state !== 0)
            writer.tag(3, WireType.Varint).int32(message.state);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 6; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string created_by_id = 7; */
        if (message.createdById !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.createdById);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkAction
 */
export const BulkAction = new BulkAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssignAppOwnersAction$Type extends MessageType<AssignAppOwnersAction> {
    constructor() {
        super("c1.api.bulkaction.v1.AssignAppOwnersAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppSearchFilter },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AssignAppOwnersAction>): AssignAppOwnersAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<AssignAppOwnersAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssignAppOwnersAction): AssignAppOwnersAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppSearchFilter filter */ 1:
                    message.filter = AppSearchFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* repeated string user_ids */ 2:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssignAppOwnersAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppSearchFilter filter = 1; */
        if (message.filter)
            AppSearchFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string user_ids = 2; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.AssignAppOwnersAction
 */
export const AssignAppOwnersAction = new AssignAppOwnersAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CatalogIds$Type extends MessageType<CatalogIds> {
    constructor() {
        super("c1.api.bulkaction.v1.CatalogIds", [
            { no: 1, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^$|^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "preserve_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^$|^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<CatalogIds>): CatalogIds {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ids = [];
        message.preserveIds = [];
        if (value !== undefined)
            reflectionMergePartial<CatalogIds>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CatalogIds): CatalogIds {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string ids */ 1:
                    message.ids.push(reader.string());
                    break;
                case /* repeated string preserve_ids */ 2:
                    message.preserveIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CatalogIds, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string ids = 1; */
        for (let i = 0; i < message.ids.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.ids[i]);
        /* repeated string preserve_ids = 2; */
        for (let i = 0; i < message.preserveIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.preserveIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.CatalogIds
 */
export const CatalogIds = new CatalogIds$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppEntitlementAccessRequestsAction$Type extends MessageType<SetAppEntitlementAccessRequestsAction> {
    constructor() {
        super("c1.api.bulkaction.v1.SetAppEntitlementAccessRequestsAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppEntitlementSearchFilter },
            { no: 2, name: "update_app_entitlement", kind: "message", T: () => AppEntitlement, options: { "validate.rules": { message: { skip: true } } } },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 5, name: "set_catalog_ids", kind: "message", oneof: "catalogs", T: () => CatalogIds },
            { no: 8, name: "ignore_catalog_ids", kind: "scalar", oneof: "catalogs", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "add_catalog_ids", kind: "message", oneof: "catalogs", T: () => CatalogIds },
            { no: 10, name: "remove_catalog_ids", kind: "message", oneof: "catalogs", T: () => CatalogIds }
        ]);
    }
    create(value?: PartialMessage<SetAppEntitlementAccessRequestsAction>): SetAppEntitlementAccessRequestsAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogs = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<SetAppEntitlementAccessRequestsAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAppEntitlementAccessRequestsAction): SetAppEntitlementAccessRequestsAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementSearchFilter filter */ 1:
                    message.filter = AppEntitlementSearchFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* c1.api.app.v1.AppEntitlement update_app_entitlement */ 2:
                    message.updateAppEntitlement = AppEntitlement.internalBinaryRead(reader, reader.uint32(), options, message.updateAppEntitlement);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* c1.api.bulkaction.v1.CatalogIds set_catalog_ids */ 5:
                    message.catalogs = {
                        oneofKind: "setCatalogIds",
                        setCatalogIds: CatalogIds.internalBinaryRead(reader, reader.uint32(), options, (message.catalogs as any).setCatalogIds)
                    };
                    break;
                case /* bool ignore_catalog_ids */ 8:
                    message.catalogs = {
                        oneofKind: "ignoreCatalogIds",
                        ignoreCatalogIds: reader.bool()
                    };
                    break;
                case /* c1.api.bulkaction.v1.CatalogIds add_catalog_ids */ 9:
                    message.catalogs = {
                        oneofKind: "addCatalogIds",
                        addCatalogIds: CatalogIds.internalBinaryRead(reader, reader.uint32(), options, (message.catalogs as any).addCatalogIds)
                    };
                    break;
                case /* c1.api.bulkaction.v1.CatalogIds remove_catalog_ids */ 10:
                    message.catalogs = {
                        oneofKind: "removeCatalogIds",
                        removeCatalogIds: CatalogIds.internalBinaryRead(reader, reader.uint32(), options, (message.catalogs as any).removeCatalogIds)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAppEntitlementAccessRequestsAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementSearchFilter filter = 1; */
        if (message.filter)
            AppEntitlementSearchFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlement update_app_entitlement = 2; */
        if (message.updateAppEntitlement)
            AppEntitlement.internalBinaryWrite(message.updateAppEntitlement, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.bulkaction.v1.CatalogIds set_catalog_ids = 5; */
        if (message.catalogs.oneofKind === "setCatalogIds")
            CatalogIds.internalBinaryWrite(message.catalogs.setCatalogIds, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool ignore_catalog_ids = 8; */
        if (message.catalogs.oneofKind === "ignoreCatalogIds")
            writer.tag(8, WireType.Varint).bool(message.catalogs.ignoreCatalogIds);
        /* c1.api.bulkaction.v1.CatalogIds add_catalog_ids = 9; */
        if (message.catalogs.oneofKind === "addCatalogIds")
            CatalogIds.internalBinaryWrite(message.catalogs.addCatalogIds, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.bulkaction.v1.CatalogIds remove_catalog_ids = 10; */
        if (message.catalogs.oneofKind === "removeCatalogIds")
            CatalogIds.internalBinaryWrite(message.catalogs.removeCatalogIds, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.SetAppEntitlementAccessRequestsAction
 */
export const SetAppEntitlementAccessRequestsAction = new SetAppEntitlementAccessRequestsAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRevokeTicketsAction$Type extends MessageType<CreateRevokeTicketsAction> {
    constructor() {
        super("c1.api.bulkaction.v1.CreateRevokeTicketsAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppEntitlementUserBindingSearchFilter },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateRevokeTicketsAction>): CreateRevokeTicketsAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<CreateRevokeTicketsAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateRevokeTicketsAction): CreateRevokeTicketsAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementUserBindingSearchFilter filter */ 1:
                    message.filter = AppEntitlementUserBindingSearchFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* string reason */ 2:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateRevokeTicketsAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementUserBindingSearchFilter filter = 1; */
        if (message.filter)
            AppEntitlementUserBindingSearchFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string reason = 2; */
        if (message.reason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.CreateRevokeTicketsAction
 */
export const CreateRevokeTicketsAction = new CreateRevokeTicketsAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppEntitlementProvisionPolicyAction$Type extends MessageType<SetAppEntitlementProvisionPolicyAction> {
    constructor() {
        super("c1.api.bulkaction.v1.SetAppEntitlementProvisionPolicyAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppEntitlementSearchFilter },
            { no: 2, name: "update_app_entitlement", kind: "message", T: () => AppEntitlement, options: { "validate.rules": { message: { skip: true } } } }
        ]);
    }
    create(value?: PartialMessage<SetAppEntitlementProvisionPolicyAction>): SetAppEntitlementProvisionPolicyAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetAppEntitlementProvisionPolicyAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAppEntitlementProvisionPolicyAction): SetAppEntitlementProvisionPolicyAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementSearchFilter filter */ 1:
                    message.filter = AppEntitlementSearchFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* c1.api.app.v1.AppEntitlement update_app_entitlement */ 2:
                    message.updateAppEntitlement = AppEntitlement.internalBinaryRead(reader, reader.uint32(), options, message.updateAppEntitlement);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAppEntitlementProvisionPolicyAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementSearchFilter filter = 1; */
        if (message.filter)
            AppEntitlementSearchFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlement update_app_entitlement = 2; */
        if (message.updateAppEntitlement)
            AppEntitlement.internalBinaryWrite(message.updateAppEntitlement, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.SetAppEntitlementProvisionPolicyAction
 */
export const SetAppEntitlementProvisionPolicyAction = new SetAppEntitlementProvisionPolicyAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetGrantExpirationAction$Type extends MessageType<SetGrantExpirationAction> {
    constructor() {
        super("c1.api.bulkaction.v1.SetGrantExpirationAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppEntitlementUserBindingSearchFilter },
            { no: 2, name: "deprovision_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<SetGrantExpirationAction>): SetGrantExpirationAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetGrantExpirationAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetGrantExpirationAction): SetGrantExpirationAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementUserBindingSearchFilter filter */ 1:
                    message.filter = AppEntitlementUserBindingSearchFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* google.protobuf.Timestamp deprovision_at */ 2:
                    message.deprovisionAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deprovisionAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetGrantExpirationAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementUserBindingSearchFilter filter = 1; */
        if (message.filter)
            AppEntitlementUserBindingSearchFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deprovision_at = 2; */
        if (message.deprovisionAt)
            Timestamp.internalBinaryWrite(message.deprovisionAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.SetGrantExpirationAction
 */
export const SetGrantExpirationAction = new SetGrantExpirationAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveGrantExpirationAction$Type extends MessageType<RemoveGrantExpirationAction> {
    constructor() {
        super("c1.api.bulkaction.v1.RemoveGrantExpirationAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppEntitlementUserBindingSearchFilter }
        ]);
    }
    create(value?: PartialMessage<RemoveGrantExpirationAction>): RemoveGrantExpirationAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RemoveGrantExpirationAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveGrantExpirationAction): RemoveGrantExpirationAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementUserBindingSearchFilter filter */ 1:
                    message.filter = AppEntitlementUserBindingSearchFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveGrantExpirationAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementUserBindingSearchFilter filter = 1; */
        if (message.filter)
            AppEntitlementUserBindingSearchFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.RemoveGrantExpirationAction
 */
export const RemoveGrantExpirationAction = new RemoveGrantExpirationAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PromoteAppManagedStateBindingAction$Type extends MessageType<PromoteAppManagedStateBindingAction> {
    constructor() {
        super("c1.api.bulkaction.v1.PromoteAppManagedStateBindingAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppManagedStateBindingSearchFilter },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<PromoteAppManagedStateBindingAction>): PromoteAppManagedStateBindingAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<PromoteAppManagedStateBindingAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PromoteAppManagedStateBindingAction): PromoteAppManagedStateBindingAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppManagedStateBindingSearchFilter filter */ 1:
                    message.filter = AppManagedStateBindingSearchFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* repeated string user_ids */ 2:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PromoteAppManagedStateBindingAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppManagedStateBindingSearchFilter filter = 1; */
        if (message.filter)
            AppManagedStateBindingSearchFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string user_ids = 2; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.PromoteAppManagedStateBindingAction
 */
export const PromoteAppManagedStateBindingAction = new PromoteAppManagedStateBindingAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssignAppEntitlementOwnersAction$Type extends MessageType<AssignAppEntitlementOwnersAction> {
    constructor() {
        super("c1.api.bulkaction.v1.AssignAppEntitlementOwnersAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppEntitlementSearchFilter },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AssignAppEntitlementOwnersAction>): AssignAppEntitlementOwnersAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<AssignAppEntitlementOwnersAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssignAppEntitlementOwnersAction): AssignAppEntitlementOwnersAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementSearchFilter filter */ 1:
                    message.filter = AppEntitlementSearchFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* repeated string user_ids */ 2:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssignAppEntitlementOwnersAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementSearchFilter filter = 1; */
        if (message.filter)
            AppEntitlementSearchFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string user_ids = 2; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.AssignAppEntitlementOwnersAction
 */
export const AssignAppEntitlementOwnersAction = new AssignAppEntitlementOwnersAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssignAppResourceOwnersAction$Type extends MessageType<AssignAppResourceOwnersAction> {
    constructor() {
        super("c1.api.bulkaction.v1.AssignAppResourceOwnersAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppResourceSearchFilter },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AssignAppResourceOwnersAction>): AssignAppResourceOwnersAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<AssignAppResourceOwnersAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssignAppResourceOwnersAction): AssignAppResourceOwnersAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppResourceSearchFilter filter */ 1:
                    message.filter = AppResourceSearchFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* repeated string user_ids */ 2:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssignAppResourceOwnersAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppResourceSearchFilter filter = 1; */
        if (message.filter)
            AppResourceSearchFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string user_ids = 2; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.AssignAppResourceOwnersAction
 */
export const AssignAppResourceOwnersAction = new AssignAppResourceOwnersAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppUserAccountTypeAction$Type extends MessageType<SetAppUserAccountTypeAction> {
    constructor() {
        super("c1.api.bulkaction.v1.SetAppUserAccountTypeAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppUserSearchFilter },
            { no: 2, name: "update_app_user_type", kind: "enum", T: () => ["c1.api.app.v1.AppUserType", AppUserType, "APP_USER_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<SetAppUserAccountTypeAction>): SetAppUserAccountTypeAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.updateAppUserType = 0;
        if (value !== undefined)
            reflectionMergePartial<SetAppUserAccountTypeAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAppUserAccountTypeAction): SetAppUserAccountTypeAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUserSearchFilter filter */ 1:
                    message.filter = AppUserSearchFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* c1.api.app.v1.AppUserType update_app_user_type */ 2:
                    message.updateAppUserType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAppUserAccountTypeAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUserSearchFilter filter = 1; */
        if (message.filter)
            AppUserSearchFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppUserType update_app_user_type = 2; */
        if (message.updateAppUserType !== 0)
            writer.tag(2, WireType.Varint).int32(message.updateAppUserType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.SetAppUserAccountTypeAction
 */
export const SetAppUserAccountTypeAction = new SetAppUserAccountTypeAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppUserOwnerAction$Type extends MessageType<SetAppUserOwnerAction> {
    constructor() {
        super("c1.api.bulkaction.v1.SetAppUserOwnerAction", [
            { no: 1, name: "filter", kind: "message", T: () => AppUserSearchFilter },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<SetAppUserOwnerAction>): SetAppUserOwnerAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<SetAppUserOwnerAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAppUserOwnerAction): SetAppUserOwnerAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUserSearchFilter filter */ 1:
                    message.filter = AppUserSearchFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* string user_id */ 2:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAppUserOwnerAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUserSearchFilter filter = 1; */
        if (message.filter)
            AppUserSearchFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string user_id = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.SetAppUserOwnerAction
 */
export const SetAppUserOwnerAction = new SetAppUserOwnerAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionRef$Type extends MessageType<BulkActionRef> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<BulkActionRef>): BulkActionRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<BulkActionRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkActionRef): BulkActionRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkActionRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionRef
 */
export const BulkActionRef = new BulkActionRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionListItemsRequest$Type extends MessageType<BulkActionListItemsRequest> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionListItemsRequest", [
            { no: 1, name: "bulk_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<BulkActionListItemsRequest>): BulkActionListItemsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bulkActionId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<BulkActionListItemsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkActionListItemsRequest): BulkActionListItemsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string bulk_action_id */ 1:
                    message.bulkActionId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkActionListItemsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string bulk_action_id = 1; */
        if (message.bulkActionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.bulkActionId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionListItemsRequest
 */
export const BulkActionListItemsRequest = new BulkActionListItemsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionListItemsResponse$Type extends MessageType<BulkActionListItemsResponse> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionListItemsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BulkActionItem },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<BulkActionListItemsResponse>): BulkActionListItemsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<BulkActionListItemsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkActionListItemsResponse): BulkActionListItemsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.bulkaction.v1.BulkActionItem list */ 1:
                    message.list.push(BulkActionItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkActionListItemsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.bulkaction.v1.BulkActionItem list = 1; */
        for (let i = 0; i < message.list.length; i++)
            BulkActionItem.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionListItemsResponse
 */
export const BulkActionListItemsResponse = new BulkActionListItemsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionListCompletedItemsRequest$Type extends MessageType<BulkActionListCompletedItemsRequest> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionListCompletedItemsRequest", [
            { no: 1, name: "bulk_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<BulkActionListCompletedItemsRequest>): BulkActionListCompletedItemsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bulkActionId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<BulkActionListCompletedItemsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkActionListCompletedItemsRequest): BulkActionListCompletedItemsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string bulk_action_id */ 1:
                    message.bulkActionId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkActionListCompletedItemsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string bulk_action_id = 1; */
        if (message.bulkActionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.bulkActionId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionListCompletedItemsRequest
 */
export const BulkActionListCompletedItemsRequest = new BulkActionListCompletedItemsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionListCompletedItemsResponse$Type extends MessageType<BulkActionListCompletedItemsResponse> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionListCompletedItemsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CompletedBulkActionItem },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<BulkActionListCompletedItemsResponse>): BulkActionListCompletedItemsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<BulkActionListCompletedItemsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkActionListCompletedItemsResponse): BulkActionListCompletedItemsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.bulkaction.v1.CompletedBulkActionItem list */ 1:
                    message.list.push(CompletedBulkActionItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkActionListCompletedItemsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.bulkaction.v1.CompletedBulkActionItem list = 1; */
        for (let i = 0; i < message.list.length; i++)
            CompletedBulkActionItem.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionListCompletedItemsResponse
 */
export const BulkActionListCompletedItemsResponse = new BulkActionListCompletedItemsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionItem$Type extends MessageType<BulkActionItem> {
    constructor() {
        super("c1.api.bulkaction.v1.BulkActionItem", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "bulk_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "state", kind: "enum", T: () => ["c1.api.bulkaction.v1.BulkActionItemState", BulkActionItemState, "BULK_ACTION_ITEM_STATE_"] },
            { no: 5, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "app_ref", kind: "message", oneof: "ref", T: () => AppRef },
            { no: 10, name: "app_entitlement_ref", kind: "message", oneof: "ref", T: () => AppEntitlementRef },
            { no: 11, name: "app_entitlement_user_binding_ref", kind: "message", oneof: "ref", T: () => AppEntitlementUserBindingRef },
            { no: 12, name: "app_user_ref", kind: "message", oneof: "ref", T: () => AppUserRef },
            { no: 13, name: "app_resource_ref", kind: "message", oneof: "ref", T: () => AppResourceRef },
            { no: 14, name: "app_managed_state_binding_ref", kind: "message", oneof: "ref", T: () => AppManagedStateBindingRef }
        ]);
    }
    create(value?: PartialMessage<BulkActionItem>): BulkActionItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.bulkActionId = "";
        message.id = "";
        message.state = 0;
        message.errorMessage = "";
        message.ref = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<BulkActionItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkActionItem): BulkActionItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string bulk_action_id */ 2:
                    message.bulkActionId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                case /* c1.api.bulkaction.v1.BulkActionItemState state */ 4:
                    message.state = reader.int32();
                    break;
                case /* string error_message */ 5:
                    message.errorMessage = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 8:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* c1.api.app.v1.AppRef app_ref */ 9:
                    message.ref = {
                        oneofKind: "appRef",
                        appRef: AppRef.internalBinaryRead(reader, reader.uint32(), options, (message.ref as any).appRef)
                    };
                    break;
                case /* c1.api.app.v1.AppEntitlementRef app_entitlement_ref */ 10:
                    message.ref = {
                        oneofKind: "appEntitlementRef",
                        appEntitlementRef: AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options, (message.ref as any).appEntitlementRef)
                    };
                    break;
                case /* c1.api.app.v1.AppEntitlementUserBindingRef app_entitlement_user_binding_ref */ 11:
                    message.ref = {
                        oneofKind: "appEntitlementUserBindingRef",
                        appEntitlementUserBindingRef: AppEntitlementUserBindingRef.internalBinaryRead(reader, reader.uint32(), options, (message.ref as any).appEntitlementUserBindingRef)
                    };
                    break;
                case /* c1.api.app.v1.AppUserRef app_user_ref */ 12:
                    message.ref = {
                        oneofKind: "appUserRef",
                        appUserRef: AppUserRef.internalBinaryRead(reader, reader.uint32(), options, (message.ref as any).appUserRef)
                    };
                    break;
                case /* c1.api.app.v1.AppResourceRef app_resource_ref */ 13:
                    message.ref = {
                        oneofKind: "appResourceRef",
                        appResourceRef: AppResourceRef.internalBinaryRead(reader, reader.uint32(), options, (message.ref as any).appResourceRef)
                    };
                    break;
                case /* c1.api.app.v1.AppManagedStateBindingRef app_managed_state_binding_ref */ 14:
                    message.ref = {
                        oneofKind: "appManagedStateBindingRef",
                        appManagedStateBindingRef: AppManagedStateBindingRef.internalBinaryRead(reader, reader.uint32(), options, (message.ref as any).appManagedStateBindingRef)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkActionItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string bulk_action_id = 2; */
        if (message.bulkActionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.bulkActionId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        /* c1.api.bulkaction.v1.BulkActionItemState state = 4; */
        if (message.state !== 0)
            writer.tag(4, WireType.Varint).int32(message.state);
        /* string error_message = 5; */
        if (message.errorMessage !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.errorMessage);
        /* google.protobuf.Timestamp created_at = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 8; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppRef app_ref = 9; */
        if (message.ref.oneofKind === "appRef")
            AppRef.internalBinaryWrite(message.ref.appRef, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementRef app_entitlement_ref = 10; */
        if (message.ref.oneofKind === "appEntitlementRef")
            AppEntitlementRef.internalBinaryWrite(message.ref.appEntitlementRef, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementUserBindingRef app_entitlement_user_binding_ref = 11; */
        if (message.ref.oneofKind === "appEntitlementUserBindingRef")
            AppEntitlementUserBindingRef.internalBinaryWrite(message.ref.appEntitlementUserBindingRef, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppUserRef app_user_ref = 12; */
        if (message.ref.oneofKind === "appUserRef")
            AppUserRef.internalBinaryWrite(message.ref.appUserRef, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppResourceRef app_resource_ref = 13; */
        if (message.ref.oneofKind === "appResourceRef")
            AppResourceRef.internalBinaryWrite(message.ref.appResourceRef, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppManagedStateBindingRef app_managed_state_binding_ref = 14; */
        if (message.ref.oneofKind === "appManagedStateBindingRef")
            AppManagedStateBindingRef.internalBinaryWrite(message.ref.appManagedStateBindingRef, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.BulkActionItem
 */
export const BulkActionItem = new BulkActionItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CompletedBulkActionItem$Type extends MessageType<CompletedBulkActionItem> {
    constructor() {
        super("c1.api.bulkaction.v1.CompletedBulkActionItem", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "bulk_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "state", kind: "enum", T: () => ["c1.api.bulkaction.v1.BulkActionItemState", BulkActionItemState, "BULK_ACTION_ITEM_STATE_"] },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "bulk_action_item", kind: "message", T: () => BulkActionItem }
        ]);
    }
    create(value?: PartialMessage<CompletedBulkActionItem>): CompletedBulkActionItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.bulkActionId = "";
        message.id = "";
        message.state = 0;
        if (value !== undefined)
            reflectionMergePartial<CompletedBulkActionItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CompletedBulkActionItem): CompletedBulkActionItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string bulk_action_id */ 2:
                    message.bulkActionId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                case /* c1.api.bulkaction.v1.BulkActionItemState state */ 4:
                    message.state = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 7:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 8:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* c1.api.bulkaction.v1.BulkActionItem bulk_action_item */ 9:
                    message.bulkActionItem = BulkActionItem.internalBinaryRead(reader, reader.uint32(), options, message.bulkActionItem);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CompletedBulkActionItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string bulk_action_id = 2; */
        if (message.bulkActionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.bulkActionId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        /* c1.api.bulkaction.v1.BulkActionItemState state = 4; */
        if (message.state !== 0)
            writer.tag(4, WireType.Varint).int32(message.state);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 7; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_at = 8; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.bulkaction.v1.BulkActionItem bulk_action_item = 9; */
        if (message.bulkActionItem)
            BulkActionItem.internalBinaryWrite(message.bulkActionItem, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.bulkaction.v1.CompletedBulkActionItem
 */
export const CompletedBulkActionItem = new CompletedBulkActionItem$Type();
/**
 * @generated ServiceType for protobuf service c1.api.bulkaction.v1.BulkActionService
 */
export const BulkActionService = new ServiceType("c1.api.bulkaction.v1.BulkActionService", [
    { name: "ListBulkAction", options: { "authz.method": { role: "VIEWER" } }, I: BulkActionListRequest, O: BulkActionListResponse },
    { name: "GetBulkAction", options: { "authz.method": { role: "VIEWER" } }, I: BulkActionGetRequest, O: BulkAction },
    { name: "CreateBulkAction", options: { "authz.method": { role: "EDITOR" } }, I: BulkActionCreateRequest, O: BulkAction },
    { name: "DeleteBulkAction", options: { "authz.method": { role: "EDITOR" } }, I: BulkActionDeleteRequest, O: Empty },
    { name: "ListBulkActionItems", options: { "authz.method": { role: "VIEWER" } }, I: BulkActionListItemsRequest, O: BulkActionListItemsResponse },
    { name: "ListCompletedBulkActionItems", options: { "authz.method": { role: "VIEWER" } }, I: BulkActionListCompletedItemsRequest, O: BulkActionListCompletedItemsResponse }
]);
